import { AccountPageContent } from "./page";

export const AccountsPage = AccountPageContent;
